export const STATUS_COLORS = {
    NEW: "#FFF",
    CALLBACK: "#007BFF33",
    NO_ANSWER: "#80808033",
    BYPASSED: "#80008033",
    LOST: "#FF000033",
    WARM: "#FFA50033",
    CONVERTED: "#228B2233",
};

const LEAD_CREATION_SOURCE_AI_CHATBOT = "AI_CHATBOT";
const LEAD_CREATION_SOURCE_OLD_FLOW = "OLD_FLOW";

const LEAD_WITH_PRESCRIPTION = "WITH";
const LEAD_WITHOUT_PRESCRIPTION = "WITHOUT";

export { LEAD_CREATION_SOURCE_AI_CHATBOT, LEAD_CREATION_SOURCE_OLD_FLOW, LEAD_WITH_PRESCRIPTION, LEAD_WITHOUT_PRESCRIPTION };